const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission_routes: state => state.permission.routes,
  userInfo: state => state.user.userInfo,
  userRoles: state => state.user.userRoles,
  pageSizes: state => state.app.pageSizes,
  pageSize: state => state.user.pageSize,
  dialogModal: state => state.user.dialogModal,
  ouType: state => state.app.ouType,
  auType: state => state.app.auType,
  chLoginName: state => state.user.chLoginName,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js